// ABOUTME: The stored format of a date field ("2027-1-15", month and day without leading zeros).
// ABOUTME: Kept apart from DateFieldElement so plain utilities can use it without loading the date picker.

import { Dayjs } from 'dayjs';

export function dateToString(date: Dayjs) {
    return `${date.year()}-${date.month() + 1}-${date.date()}`;
}
